import { render } from "./MyApp.vue?vue&type=template&id=36f68206&scoped=true"
import script from "./MyApp.vue?vue&type=script&lang=js"
export * from "./MyApp.vue?vue&type=script&lang=js"

import "./MyApp.vue?vue&type=style&index=0&id=36f68206&scoped=true&lang=css"

import exportComponent from "/home/jiaxf/prod/fltrp-dams-admin-ui/builds/VjEGYzGkB/0/unilearn/unilearn-web-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f68206"]])

export default __exports__